import type { UserPermissionType as SharedUserPermissionType } from '@gasbi/shared';

// SBA's permission names are the backend's `SbaPermissions` strings as they arrive ("Area.Action"),
// not the shared "resource.entity.access" template, so they are branded once here.
export type UserPermissionType = SharedUserPermissionType;

const permission = (name: string) => name as UserPermissionType;

// Mirrors Gasbi.Supply.Business.Account.Domain.Constants.SbaPermissions
export const UserPermissions = {
  DashboardRead: permission('Dashboard.Read'),
  OrganizationRead: permission('Organization.Read'),
  OrganizationUpdate: permission('Organization.Update'),
  ContractsRead: permission('Contracts.Read'),
  MeteringPointsRead: permission('MeteringPoints.Read'),
  ConsumptionRead: permission('Consumption.Read'),
  AccrualsRead: permission('Accruals.Read'),
  PaymentsRead: permission('Payments.Read'),
  DebtsRead: permission('Debts.Read'),
  InvoicesRead: permission('Invoices.Read'),
  InvoicesDownload: permission('Invoices.Download'),
  PlannedVolumesRead: permission('PlannedVolumes.Read'),
  PlannedVolumesUpdate: permission('PlannedVolumes.Update'),
  DocumentsUpload: permission('Documents.Upload'),
  ActsRead: permission('Acts.Read'),
  ConnectionApplicationsRead: permission('ConnectionApplications.Read'),
  ConnectionApplicationsCreate: permission('ConnectionApplications.Create'),
  AppealsRead: permission('Appeals.Read'),
  AppealsCreate: permission('Appeals.Create'),
  UsersRead: permission('Users.Read'),
  UsersCreate: permission('Users.Create'),
  UsersUpdate: permission('Users.Update'),
  UsersChangeRole: permission('Users.ChangeRole'),
  UsersDeactivate: permission('Users.Deactivate'),
  AuditRead: permission('Audit.Read'),
} as const;
